export default {

  amount: 'amount',
  sms: 'sms',
  email: 'email',

  dispenser_cassette_id: 'Cassette ID',
  dispenser_cassette_id_description: 'Device cassette identifier (should start from 1 and increase sequentially: 2, 3, 4, ...)',

  dispenser_count_load: 'Cash Added',
  dispenser_count_load_description: 'Number of cash notes inserted during the last technician visit',

  dispenser_count_cassette: 'Available',
  dispenser_count_cassette_description: 'Number of cash notes currently in the dispenser cassette',

  dispenser_count_reject: 'Rejected',
  dispenser_count_reject_description: 'Number of cash notes currently in the reject box',

  denomination_description: 'Note denomination',

  dispenser_count_dispense: 'Dispensed',
  dispenser_count_dispense_description: 'Number of cash notes dispensed through the window',

  header_dispenser_cassettes: 'Cassettes',
  header_change_logs: 'Change Logs',

  denomination: 'Denomination',
  column_denomination: 'Denomination',

  currency_code: 'Currency',

  save: 'Save',
  delete: 'Delete',

  column_id: 'ID',
  column_guid: 'Guid',
  column_user: 'User',
  column_date: 'Date',
  column_location: 'Location',
  column_location_name: 'Business Name',
  column_address: 'Address',
  column_application: 'Application',
  column_locale: 'Locale',
  column_partner: 'Partner',
  column_device: 'Device',
  column_status: 'Status',
  column_amount: 'Amount',
  column_cash_amount: 'Cash Amount',
  column_coin_amount: 'Coin Amount',
  column_notes: 'Notes',
  column_state_before: 'Previous State',
  column_state_after: 'New State',
  column_customer: 'Customer Mobile',
  column_last_seen: 'Last Seen',
  column_mobile: 'Mobile',

  action_amount_is_not_set: 'Amount is not set!',

  action_removed_question: 'Do you want to remove this?',
  action_removed_success: 'Removed successfully',

  device_actions_column_1_label: 'Rebooting',
  device_actions_column_2_label: 'Tech. operations',
  device_actions_column_3_label: 'Images',
  device_actions_column_4_label: 'Other...',

  device_action_scan_image_label: 'Scan Image',
  device_action_scan_image_title: 'Capture image from camera box',
  device_action_scan_image_question: 'Do you want to scan an image?',
  device_action_scan_image_success: 'Image scanned successfully',

  device_action_scan_face_label: 'Scan Face',
  device_action_scan_face_title: 'Capture image from front camera',
  device_action_scan_face_question: 'Do you want to scan a face?',
  device_action_scan_face_success: 'Face scanned successfully',

  device_action_scan_restart_agent_question: 'Do you want to restart the agent?',
  device_action_scan_restart_agent_success: 'Restarting agent...',

  device_action_make_screenshot_label: 'Take Screenshot',
  device_action_make_screenshot_title: 'Screenshot of clamshell view',
  device_action_make_screenshot_question: 'Do you want to take a screenshot?',
  device_action_make_screenshot_success: 'Screenshot taken successfully',

  device_action_coin_dispense_label: 'Dispense Coins',
  device_action_coin_dispense_title: 'Enter coin amount to dispense',
  device_action_coin_dispense_question: 'Please enter the number of dollars to dispense',
  device_action_coin_dispense_success: 'Coins dispensed successfully',
  device_action_coin_dispense_all_success: 'All coins dispensed successfully',

  device_action_release_dispenser_title: 'Release Cassettes',
  device_action_release_dispenser_label: 'Release Cassettes',
  device_action_release_dispenser: 'Do you want to release cassettes and reset the reject counter?',

  device_action_empty_unit_title: 'Empty Unit',
  device_action_empty_unit_label: 'Empty Unit',
  device_action_empty_unit: 'Do you want to empty the cash unit?',
  device_action_empty_unit_success: 'Executed successfully',

  device_action_jam_reset_title: 'Jam Reset',
  device_action_jam_reset_label: 'Jam Reset',
  device_action_jam_reset: 'Do you want to reset the jam?',
  device_action_jam_reset_success: 'Executed successfully',

  device_action_start_learning_title: 'Start Learning',
  device_action_start_learning_label: 'Start Learning',
  device_action_start_learning: 'Do you want to start the learning process?',
  device_action_start_learning_success: 'Executed successfully',

  device_action_coin_dispense_all_label: 'Dispense All Coins',
  device_action_coin_dispense_all_title: 'Empty coin recycler',
  device_action_coin_dispense_all_question: 'Do you want to dispense all coins?',
  device_action_release_dispenser_success: 'Dispenser released successfully',

  device_action_coin_escrow_label: 'Coin Escrow',
  device_action_coin_escrow_title: 'Prompt Recycler',
  device_action_coin_escrow_question: 'Do you want to escrow coins?',
  device_action_coin_escrow_success: 'Coins escrowed successfully',

  device_action_cash_escrow_label: 'Cash Escrow',
  device_action_cash_escrow_title: 'Load Cash',
  device_action_cash_escrow_question: 'Do you want to escrow cash?',
  device_action_cash_escrow_success: 'Cash escrowed successfully',

  device_action_cash_dispense_label: 'Dispense Cash',
  device_action_cash_dispense_title: 'Enter cash amount to dispense',

  device_action_reboot_label: 'Reboot',
  device_action_reboot_title: 'Power Cycle Device',
  device_action_reboot_question: 'Do you want to reboot the device?',
  device_action_reboot_success: 'Command executed successfully',

  device_action_restart_browser_label: 'Restart Browser',
  device_action_restart_browser_title: 'Refresh web application',
  device_action_restart_browser_question: 'Do you want to restart the browser?',
  device_action_restart_browser_success: 'Command executed successfully',

  device_action_restart_adv_browser_label: 'Restart Adv. Browser',
  device_action_restart_adv_browser_title: 'Refresh advertising screen',
  device_action_restart_adv_browser_question: 'Do you want to restart the advertising browser?',
  device_action_restart_adv_browser_success: 'Command executed successfully',

  device_action_restart_agents_label: 'Restart Agents',
  device_action_restart_agents_title: 'Restart hardware agents',
  device_action_restart_agents_question: 'Do you want to restart the agents?',
  device_action_restart_agents_success: 'Command executed successfully',

  device_action_maintenance_start_label: 'Start Maintenance',
  device_action_maintenance_start_title: 'Start Maintenance',
  device_action_maintenance_start_question: 'Do you want to start maintenance?',
  device_action_maintenance_start_success: 'Command executed successfully',

  device_action_set_new_kiosk_label: 'Assign New Kiosk',
  device_action_set_new_kiosk_title: 'Set New Kiosk Number',
  device_action_set_new_kiosk__question: 'Do you want to assign this kiosk as the new kiosk (777)?',
  device_action_set_new_kiosk__success: 'Command executed successfully',

  device_action_calibration_start_label: 'Start Calibration',
  device_action_calibration_start_title: 'Start screen calibration',
  device_action_calibration_start_question: 'Do you want to start calibration?',
  device_action_calibration_start_success: 'Command executed successfully',

  device_action_print_last_label: 'Print Last Receipt',
  device_action_print_test_label: 'Print Test Receipt',
  device_action_print_label: 'Print',
  device_action_print_title: 'Print last receipt',
  device_action_print_question: 'Do you want to print?',
  device_action_print_success: 'Command executed successfully',

  device_action_test_network_label: 'Test Network',
  device_action_test_network_question: 'Do you want to test the network?',
  device_action_test_network_success: 'Command executed successfully',

  device_action_card_reader_test_label: 'Test Card Reader',
  device_action_card_reader_test_title: 'Check card reader functionality',
  device_action_card_reader_test_question: 'Do you want to test the card reader?',
  device_action_card_reader_test_success: 'Command executed successfully',

  device_action_advertise_screen_label: 'Advertise Screen',
  device_action_advertise_screen_question: 'Do you want to change the advertisement screen?\nPlease enter the new advertisement link:',
  device_action_advertise_screen_success: 'Command executed successfully',

  device_action_soft_update_label: 'Soft Update',
  device_action_soft_update_title: 'Pull updates from Maya API',
  device_action_soft_update_question: 'Do you want to perform a soft update?',
  device_action_soft_update_success: 'Command executed successfully',

  device_action_hard_update_label: 'Hard Update',
  device_action_hard_update_title: 'Cycle and pull from Git',
  device_action_hard_update_question: 'Do you want to perform a hard update?',
  device_action_hard_update_success: 'Command executed successfully',

  device_action_free_transaction_label_on: 'Free Trx On',
  device_action_free_transaction_title_on: 'Turn on Free Transaction Mode',
  device_action_free_transaction_question_on: 'Do you want to turn on free transaction mode?',
  device_action_free_transaction_success_on: 'Free transaction mode turned on successfully',

  device_action_free_transaction_label_off: 'Free Trx Off',
  device_action_free_transaction_title_off: 'Turn off Free Transaction Mode',
  device_action_free_transaction_question_off: 'Do you want to turn off free transaction mode?',
  device_action_free_transaction_success_off: 'Free transaction mode turned off successfully',

  device_action_test_speed_label: 'Test Speed',
  device_action_test_speed_title: 'Run speed test',
  device_action_test_speed_question: 'Do you want to run a speed test?',
  device_action_test_speed_success: 'Command executed successfully',

  device_action_update_led_label: 'Update LED',
  device_action_update_led_title: 'Run LED update',
  device_action_update_led_question: 'Do you want to update the LED?',
  device_action_update_led_success: 'Command executed successfully',

  device_action_down_on_maintenance_question: 'Do you want to set this device to maintenance mode?\nPlease enter the reason:',
  device_action_down_on_maintenance_default_message: 'Down for maintenance',
  device_action_open_door_message: 'Door opened successfully',
  device_action_down_on_maintenance_success: 'Command executed successfully',

  device_action_jam_refresh_success: 'Command executed successfully',
  device_action_pin_code_get_success: 'Command executed successfully',

  device_action_switch_mode_question_fn: nextState => `Do you want to switch the device to ${nextState} mode?\nNote: this will take approximately 30 seconds`,
  device_action_switch_mode_success: 'Command executed successfully',

  device_action_switch_enabled_fn: nextState => `Do you want to set the device status to ${nextState}?`,
  device_action_switch_enabled_success: 'Command executed successfully',

  device_action_category_set_question: 'Do you want to change the category for this device?',
  device_action_category_set_success: 'Category updated successfully',

  device_action_location_set_success: 'Location updated successfully',
  device_action_partner_set_success: 'Partner updated successfully',

  device_settings_action_create_template_question: 'Enter a label for the new template',
  device_settings_action_create_template_success: 'Template created successfully',
  device_settings_action_save_template_success: 'Template saved successfully',
  device_settings_action_move_template_success: 'Template moved successfully',
  device_settings_action_toggle_template_success: 'Template toggled successfully',

  device_settings_action_save_device_settings_question: 'Do you want to save your changes?\nNote: This will update the kiosk',
  device_settings_action_save_device_settings_success: 'Device settings saved successfully',
  device_action_delete_success: 'You successfully deleted this machine',

  location_action_create_question: 'Do you want to create a new location?',
  location_action_create_success: 'Location created successfully',
  location_action_update_success: 'Location updated successfully',
  location_action_set_category_question: 'Do you want to apply this category to all devices at this location?',
  location_action_set_category_success: 'Category applied successfully',

  payment_action_refund_allow_question: value => `Do you want to refund a payment of $${value}?`,
  payment_action_refund_allow_success: 'Command executed successfully',
  payment_action_refund_deny_question: 'Do you want to deny the refund?',
  payment_action_refund_deny_success: 'Command executed successfully',

  partner_action_create_question: 'Enter a name for the new partner:',
  partner_action_create_success: 'Partner created successfully',
  partner_action_delete_question: 'Are you sure you want to delete this partner?',
  partner_action_delete_success: 'Partner deleted successfully',
  partner_action_rename_success: 'Partner renamed successfully',
  partner_action_move_success: 'Partner moved successfully',

  category_action_create_root_question: 'Enter a name for the new root category:',
  category_action_create_root_success: 'Category created successfully',
  category_action_create_success: 'Category created successfully',
  category_action_delete_success: 'Category deleted successfully',
  category_action_rename_success: 'Category renamed successfully',

  category_action_change_icon_question: 'Set the image URL for this category.',
  category_action_change_icon_success: 'Image URL set successfully',

  category_action_duplicate_question: 'Do you want to duplicate this category?',
  category_action_duplicate_success: 'Category duplicated successfully',

  category_action_set_partner_question_fn: (category, partner) => `Do you want to assign ${category} to partner: ${partner}?`,
  category_action_set_partner_success: 'Partner assigned successfully',

  preferences_section_alerts_title: 'Alert Preferences',
  preferences_action_save_alerts_success: 'Alert preferences saved',

  preferences_alerts_column_payments_title: 'Payments',
  preferences_alerts_column_devices_title: 'Machines',
  preferences_alerts_column_b2b_title: 'Vendor',

  preferences_alerts_failed_b2b_calls_title: 'Failed Vendor Calls',
  preferences_alerts_failed_b2b_calls_description: 'Receive alerts when vendor API calls fail.',

  preferences_alert_actual_amount_title: 'Amount Threshold',
  preferences_alert_actual_amount_description: 'Send alerts for payments above the specified amount',

  preferences_alert_failed_payments_title: 'Failed Payments',
  preferences_alert_failed_payments_description: 'Receive alerts when a payment fails.',

  preferences_alert_check_review_title: 'Check Under Review',
  preferences_alert_check_review_description: 'Receive alerts when a check is under review.',

  preferences_alert_device_offline_title: 'Kiosk Offline',
  preferences_alert_device_offline_description: 'Alert when kiosk is offline for more than 10 minutes',

  preferences_alert_device_disconnected_title: 'Kiosk Disconnected',
  preferences_alert_device_disconnected_description: 'Alert when the kiosk has connection issues',

  preferences_alert_coin_acceptor_low_title: 'Low Coins',
  preferences_alert_coin_acceptor_low_description: 'Alert when the coin acceptor is low',

  preferences_alert_cash_dispenser_low_title: 'Low Cash',
  preferences_alert_cash_dispenser_low_description: 'Alert when the cash dispenser is low',

  preferences_alert_cash_acceptor_full_title: 'Cash Acceptor Full',
  preferences_alert_cash_acceptor_full_description: 'Alert when the cash acceptor is nearly full',

  preferences_alert_low_receipt_paper_title: 'Low Receipt Paper',
  preferences_alert_low_receipt_paper_description: 'Alert when receipt paper is low',

  preferences_alert_no_receipt_paper_title: 'No Receipt Paper',
  preferences_alert_no_receipt_paper_description: 'Alert when receipt paper has run out',

  preferences_alert_bill_acceptor_jam_title: 'Bill Acceptor Jam',
  preferences_alert_bill_acceptor_jam_description: 'Alert when the bill acceptor is jammed',

  preferences_alert_coin_acceptor_jam_title: 'Coin Acceptor Jam',
  preferences_alert_coin_acceptor_jam_description: 'Alert when the coin acceptor is jammed',

  preferences_alert_cash_dispenser_jam_title: 'Cash Dispenser Jam',
  preferences_alert_cash_dispenser_jam_description: 'Alert when the cash dispenser is jammed',

  preferences_alert_bill_recycler_jam_title: 'Bill Recycler Jam',
  preferences_alert_bill_recycler_jam_description: 'Alert when the bill recycler is jammed',

  preferences_alert_bill_recycler_offline_title: 'Recycler Offline',
  preferences_alert_bill_recycler_offline_description: 'Bill recycler connection loss alerts',

  preferences_alert_bill_recycler_out_of_phase_title: 'Recycler Verification Required',
  preferences_alert_bill_recycler_out_of_phase_description: 'Bill recycler requires manual denomination verification',

  preferences_alert_bill_recycler_error_title: 'Recycler Error',
  preferences_alert_bill_recycler_error_description: 'Alert when the bill recycler reports a hardware error',

  preferences_alert_recycler_full_title: 'Recycler Inventory Full',
  preferences_alert_recycler_full_description: 'Alert when the bill recycler inventory is full',

  preferences_alert_recycler_low_title: 'Recycler Inventory Low',
  preferences_alert_recycler_low_description: 'Alert when the bill recycler inventory is low',

  preferences_alert_check_reader_jam_title: 'Check Reader Jam',
  preferences_alert_check_reader_jam_description: 'Alert when the check reader is jammed',

  payment_action_update_x_data_success: 'Payment data updated successfully',
  session_action_update_x_data_success: 'Session data updated successfully',

  product_action_change_icon_question: 'Set the image URL for this product. Format: /resources/img/countries/Mexico.png',
  product_action_change_name_question: 'Set the name for this product',
  product_action_change_title_question: 'Set the title for this product',
  product_action_change_success: 'Product updated successfully',

  promotion_button_select_file_label: 'Choose CSV file with phone numbers',

  promotion_action_send_messages_question_fn: (customerCount) =>
    `This message will be sent to ${customerCount} customers. Are you sure you want to send it?`,
  promotion_action_send_messages_success: 'Messages sent successfully'

}



// WEBPACK FOOTER //
// ./src/languages/English.js